import { useEffect, useState } from 'react';

import { api } from '@/context/AuthContext';

/**
 * Livro em destaque — a leitura do mês corrente.
 *
 * O endpoint /livros/destaque devolve o livro marcado pelo admin.
 * Quando não há nenhum marcado, cai para o mais recente de /livros,
 * que é o comportamento que a Home antiga já tinha.
 */
export const useLivroDestaque = () => {
  const [livro, setLivro] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;

    const encerrar = (valor) => {
      if (!ativo) return;
      setLivro(valor);
      setCarregando(false);
    };

    api
      .get('/livros/destaque')
      .then(({ data }) => encerrar(data ?? null))
      .catch(() =>
        api
          .get('/livros')
          .then(({ data }) =>
            encerrar(data?.length ? data[data.length - 1] : null),
          )
          .catch(() => encerrar(null)),
      );

    return () => {
      ativo = false;
    };
  }, []);

  return { livro, carregando };
};

/**
 * Acervo: tudo que já foi lido, do mais recente para o mais antigo.
 * O mês vem do próprio registro, então é ele que decide a cor de cada
 * capa — sem campo extra no banco.
 */
export const useAcervo = () => {
  const [livros, setLivros] = useState([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;

    api
      .get('/livros')
      .then(({ data }) => {
        if (!ativo) return;
        const ordenados = [...(data ?? [])].sort(
          (a, b) => new Date(b.month) - new Date(a.month),
        );
        setLivros(ordenados);
      })
      .catch(() => {
        if (ativo) setLivros([]);
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });

    return () => {
      ativo = false;
    };
  }, []);

  return { livros, carregando };
};

/** 'setembro', 'outubro' — sempre em UTC, pelo mesmo motivo do hue. */
export const nomeDoMes = (data) => {
  if (!data) return '';
  const d = data instanceof Date ? data : new Date(data);
  if (Number.isNaN(d.getTime())) return '';

  return new Intl.DateTimeFormat('pt-BR', {
    month: 'long',
    timeZone: 'UTC',
  }).format(d);
};
